import styled from 'styled-components';

export const ChartTitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 14px;
  font-size: 14px;
  font-weight: 400;
  white-space: nowrap;
  margin-bottom: var(--spacing-xl);
`;

export const TitleInput = styled.input`
  padding: var(--spacing-s) var(--spacing-m);
  border-radius: var(--radius-4);
  border: 1px solid #dfe3e7;
  height: 40px;
  width: 100%;
`;
